import React from 'react';
import './CheckoutLinkForm.css';

function CheckoutLinkForm({url, method, inputs, customSubmitLabel, disabled, onSubmit}) {
    const handleSubmit = () => {
        if (onSubmit) onSubmit();
    };

    const getInputValue = (input) => {
        if (input.type === 'submit' && customSubmitLabel) return customSubmitLabel;
        else return input.value;
    };

    const renderInputs = () => {
        if (inputs && inputs.length > 0) {
            return inputs.map((input, index) => (
                <input key={`checkout-link-form_input-${index}`} className={`checkout-link-form_${(input.name || input.value).toLowerCase()}`} type={input.type} name={input.name} value={getInputValue(input)} readOnly={true} disabled={disabled}/>
            ));
        } else return undefined
    };

    return (
        <form className='checkout-link-form' action={url} method={method} onSubmit={handleSubmit}>
            {renderInputs()}
        </form>
    );
}

export default CheckoutLinkForm;